// Sparade platser ("min uppfart", "sommarstugan") i webbläsaren. Ingen
// inloggning, inga uppgifter till servern – allt ligger i localStorage.

import { DEFAULT_SITE, type Site } from "./vehicle-fit";

export type SavedSite = { id: string; name: string; site: Site; savedAt: number };

const KEY = "akhb.fit.sites.v1";

export function loadSites(): SavedSite[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as SavedSite[];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((s) => s && typeof s.name === "string" && s.site)
      .map((s) => ({ ...s, site: { ...DEFAULT_SITE, ...s.site } }))
      .slice(0, 12);
  } catch {
    return [];
  }
}

function persist(list: SavedSite[]) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
  } catch {
    /* full eller privat läge – strunt samma */
  }
}

export function saveSite(name: string, site: Site): SavedSite[] {
  const clean = name.trim().slice(0, 40) || "Min uppfart";
  const list = loadSites().filter((s) => s.name.toLowerCase() !== clean.toLowerCase());
  const next: SavedSite[] = [
    { id: `${Date.now()}`, name: clean, site, savedAt: Date.now() },
    ...list,
  ];
  persist(next);
  return next;
}

export function removeSite(id: string): SavedSite[] {
  const next = loadSites().filter((s) => s.id !== id);
  persist(next);
  return next;
}
